
    import Vue from 'vue';
    import { RouterLink } from 'vue-router'
    import FilePathService from '@/apps/shared/services/filePath-service';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import localityService from '@/apps/shared/services/locality-service';
    import ivaConditionService from '@/apps/shared/services/ivaConditions-service';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    export default Vue.extend({
        components: {
            RouterLink,
            WhatsApp,
            XBreadcrumb,
        },
        busEvents: {
        },
        name: 'declaracionJurada-view',
        data() {
            return {
                buttonDisable: true,
                isInjured: false,
                isMedicated: false,
                capital: null,
                BreadcrumbText: "Datos de la persona a Cubrir",
                additionalCovers: [],
                coversDetail: [],
                planName: null,
                effectDate: null,
                primerCuota: 0,
                DataPlan: {
                    planDescription: ''
                },
                expirationDate: null,
                activeStep: 0,
                docTypeSelected: [{ id: "", name: "" }],
                personToCoverDocTypeSelected: null,
                ivaConditionSelected: null,
                documentTypeList: [{ id: "", text: "" }],
                ivaConditionList: [{ id: "", text: "" }],
                maxSelections: 2,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                numDoc: null,
                personToCoverNumDoc: null,
                isNotSelectedDocumentType: true,
                isPersonToCoverNotSelectedDocumentType: true,
                searchButtonDisable: true,
                payButtonDisable: true,
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                telephone: '',
                streetName: null,
                birthday: null,
                messageErrorAge: null,
                age: '0',
                stringDate: '',
                piso: null,
                numDom: null,
                numDept: null,
                areaCode: '',
                email: '',
                selectedLocality: null,
                cityName: null,
                cityId2: null,
                localityId: null,
                zipCode: null,
                Procesoautomatico: false,
                MaximDigitSuperatedDni: false,
                isPersonExist: true,
                activeForm: false,
                minimumInputLength: 4,
                accept: true,
                coberturasAmparo: [],
                gender: null,
                officeId: null,
                city: null,
                address: null,
                selectedIvaCondition: null,
                province: null,
                genderId: null,
                firstName: "",
                lastName: "",
                activeFormPersonNotExist: false,
                hasLocality: false,
                localityIsSelected: true,
                disable: true,
                validatePhone: false,
                messageErrorAreaCode: null,
                messageErrorPhone: null,
                messageError: null,
                messageErrorDigits: null,
                validDigits: null,
                numDocChange: null,
                numDocExisting: null,
                totalStep: null,
                currenStep: null,
                currentGroup: null,
                isLastStep: true,
                breadcrumItems: [
                    { text: 'Inicio', path: '/salud-segura-max' },
                    { text: 'Datos de la Persona a Cubrir', path: '/salud-segura-max/datosAsegurado' }
                ],
                premiumWithoutDiscount: null,
                thereIsDiscount: false,
                leadId: null,
                personArray: [],
                personArraySaved: [],
                clientData: null,
                familyMembers: null,
                weightErrors: {},
                heightErrors: {},
                injuredComentErrors: {},
                medicatedComentErrors: {},
                isValid: false
            };
        },
        created() {
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Salud Segura Max';
                const actualPath = '/salud-segura-max';
                // Llamamos al helper que se encarga de toda la lógica
                await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultSafeHealthMaxGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            openCancelModal: function () {
                this.$refs.cancelModal.open();
            },
            closeCancelModal: function () {
                this.$refs.cancelModal.close();
            },
            anterior() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'healthMaxPolicyOwner-view',
                })
            },
            pagar() {
                sessionStorage.setItem("pressBack", "false");
                CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, null, null, 321, false, "4", null, null, null);
                sessionStorage.setItem("SwornDeclarationArray", JSON.stringify(this.personArraySaved));
                this.$router.push({ name: 'HealtMaxSummary' });
            },
            changeTitleAndIcon() {
                // L�gica para determinar el nuevo t�tulo
                const newTitle = 'Salud Segura Max';
                // Emite eventos para actualizar el t�tulo
                this.$emit('updateTitle', newTitle);
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear().toString();
                return `${day}/${month}/${year}`;
            },
            showFileError(errorMessage) {
                NF.Notification.show({
                    type: NF.Notification.Type.ERROR,
                    title: 'Error',
                    content: errorMessage,
                    position: NF.Notification.Positions.TOP_RIGHT,
                    clickClose: true,
                    autoHideDelay: 0
                })
            },
            getFilePath() {
                this.closeCancelModal();
                this.$router.push({ name: 'healthMaxHome-view' });
            },
            grabar(id, peso, altura, isInjured, injuredComent, isMedicated, medicatedComent) {
                if (this.validateAll(id)) {
                    this.personArraySaved[id] = JSON.parse(JSON.stringify(this.personArray[id]));
                    this.personArray[id].isSaved = true;
                    this.isValid = true;
                    this.validateSaved();
                    this.cerrarCollapsed(id);
                } else {
                    this.isValid = false;
                }
            },
            validateAll(id) {
                var validate = true;
                validate = this.validatePeso(id) == false ? false : validate;
                validate = this.validateAltura(id) == false ? false : validate;
                validate = this.validateInjuredComent(id) == false ? false : validate;
                validate = this.validateMedicatedComent(id) == false ? false : validate;
                return validate;
            },
            cerrarCollapsed(id) {
                // Buscar el botón del colapso
                const trigger = document.querySelector('[href="#collapse' + id + '"]') as HTMLElement | null;

                //simular clic para cerrarlo con animación
                const panel = document.querySelector('#collapse' + id);
                if (panel && panel.classList.contains('in')) {
                    trigger?.click(); //dispara el cierre
                }
            },
            preparePersonArray: function (isIndividual) {
                this.personArray.push({
                    completeName: this.clientData.firstName + " " + this.clientData.lastName,
                    weight: null,
                    height: null,
                    isInjured: false,
                    injuredComent: '',
                    isMedicated: false,
                    medicatedComent: '',
                    isSaved: false
                });
                if (!isIndividual) {
                    this.familyMembers.forEach((fm, i) => {
                        this.personArray.push({
                            completeName: fm.firstName + " " + fm.lastName,
                            weight: null,
                            height: null,
                            isInjured: false,
                            injuredComent: '',
                            isMedicated: false,
                            medicatedComent: '',
                            isSaved: false
                        });
                    });
                }
            },
            validateSaved() {
                this.personArray.forEach((_, index) => {
                    if (!this.personArray[index].isSaved) {
                        this.isValid = false;
                        return false;
                    };
                });
                return true;
            },
            validatePeso(index) {
                const peso = this.personArray[index].weight;
                if (peso === null || peso === '' || isNaN(peso) || peso === '0') {
                    this.$set(this.weightErrors, index, 'El peso es obligatorio');
                    return false;
                } else if (peso > 500) {
                    this.$set(this.weightErrors, index, 'El peso no puede ser mayor de 500Kg.');
                    return false;
                } else {
                    this.$delete(this.weightErrors, index);
                    return true;
                }
            },
            validateAltura(index) {
                const altura = this.personArray[index].height;
                if (altura === null || altura === '' || isNaN(altura) || altura === '0') {
                    this.$set(this.heightErrors, index, 'La altura es obligatoria');
                    return false;
                } else if (altura > 300) {
                    this.$set(this.heightErrors, index, 'la altura no puede ser mayor de 300Cm.');
                    return false;
                } else {
                    this.$delete(this.heightErrors, index);
                    return true;
                }
            },
            validateInjuredComent(index) {
                const injuredComent = this.personArray[index].injuredComent;
                const isInjured = this.personArray[index].isInjured;
                if (isInjured && (injuredComent === null || injuredComent === '' || injuredComent.length == 0)) {
                    this.$set(this.injuredComentErrors, index, 'El comentario es obligatorio');
                    return false;
                } else {
                    this.$delete(this.injuredComentErrors, index);
                    return true;
                }
            },
            validateMedicatedComent(index) {
                const medicatedComent = this.personArray[index].medicatedComent;
                const isMedicated = this.personArray[index].isMedicated;
                if (isMedicated && (medicatedComent === null || medicatedComent === '' || medicatedComent.length == 0)) {
                    this.$set(this.medicatedComentErrors, index, 'El comentario es obligatorio');
                    return false;
                } else {
                    this.$delete(this.medicatedComentErrors, index);
                    return true;
                }
            },
            getInitialData()
            {
                this.thereIsDiscount = sessionStorage.getItem("thereIsDiscount") === 'true';
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                this.currentGroup = parseInt(JSON.parse(sessionStorage.getItem("groupSelected")).id);
                this.clientData = JSON.parse(sessionStorage.getItem("clientData"));
                this.familyMembers = JSON.parse(sessionStorage.getItem("familyMembers"));

                let coversCapitalAndDescription = JSON.parse(sessionStorage.getItem("getHealthCoverCapitalAndDescription-Group" + (this.currentGroup)));
                this.coversDetail = coversCapitalAndDescription;
                let gridCovers = JSON.parse(sessionStorage.getItem("responseGetVWHealthGridCovers"));
                // Extraer listado de beneficios adicionales
                let peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"));
                let groupId = peopleToCover === 1 ? 1 : 3;
                this.additionalCover = gridCovers.vwGridCovers.filter(item => item.gridCategoriesId === 2 && item.verticalGroupsId.includes(groupId)).map(item => {
                    return {
                        coverDescription: item.coverDescription.trim()
                    };
                });
                let planData = JSON.parse(sessionStorage.getItem("responseHealth321Quotation"));
                const formatDate = (dateString: string): string => {
                    const date = new Date(dateString);
                    const day = date.getDate().toString().padStart(2, '0');
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const year = date.getFullYear().toString();
                    return `${day}/${month}/${year}`;
                };

                // Asignar las fechas formateadas
                this.effectDate = formatDate(planData.effectDate);
                this.expirationDate = formatDate(planData.expirationDate);
                let group = JSON.parse(sessionStorage.getItem("groupSelected"));
                this.planName = group.name;               
                this.totalStep = sessionStorage.getItem("totalStep");
                this.currenStep = this.totalStep - 1;
                let planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected"));
                this.preparePersonArray(planDataSelected.planDescription == "Plan Individual" ? true : false);
                if (planDataSelected != null) {
                    this.DataPlan = planDataSelected!;
                    this.primerCuota = this.DataPlan.premioMensual;
                    this.premiumWithoutDiscount = this.thereIsDiscount ? this.DataPlan.premiumWithoutDiscount : null;
                    this.capital = this.DataPlan.capital;
                }

            }
        },
        watch: {
            personArray: {
                handler(newVal) {
                    newVal.forEach((person, index) => {
                        const oldPerson = this.personArraySaved?.[index];
                        if (!oldPerson) return;

                        if (
                            person.weight !== oldPerson.weight ||
                            person.height !== oldPerson.height ||
                            person.isInjured !== oldPerson.isInjured ||
                            person.injuredComent !== oldPerson.injuredComent ||
                            person.isMedicated !== oldPerson.isMedicated ||
                            person.medicatedComent !== oldPerson.medicatedComent
                        ) {
                            this.personArray[index].isSaved = false;
                            this.validateSaved();
                        }
                    });
                },
                deep: true,
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                
                const parallelPromises = [
                    this.pageCustomization(),
                    this.changeTitleAndIcon(),
                    this.getInitialData()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

            } finally {
                NF.UI.Page.unblock();
            }
        }
    })
